<template>
  <div class="radio">
    <label :for="name" class="radio-label">
      <div :class="{ 'radio-wrapper': true, checked: value }">
        <div class="checked-radio"></div>
      </div>
      <input
        :id="name"
        :name="name"
        class="input"
        type="radio"
        :checked="value"
      />
      <span v-if="title" class="radio-title">{{ title }}</span>
    </label>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Radio',
  props: ['title', 'name', 'value']
})
export default class RadioComponent extends Vue {}
</script>

<style lang="scss" scoped>
.radio {
  position: relative;
  height: 16px;
  min-width: 16px;
  margin-right: 40px;
  &:last-child {
    margin-right: 0;
  }
  .input {
    position: absolute;
    appearance: none;
  }
  .radio-label {
    display: flex;
    align-items: center;
    height: 100%;
    width: auto;
    font-size: $fourteenSize;
    cursor: pointer;
    .radio-wrapper {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      display: block;
      width: 16px;
      height: 16px;
      border-radius: 8px;
      border: 1px solid $checkbox-border;
      background: $white;
      transition: background 0.1s linear, border 0.1s linear;
      z-index: 0;
      &.checked {
        background: $main-green;
        border: 1px solid $main-green;
      }
      .checked-radio {
        position: absolute;
        top: 4px;
        left: 4px;
        width: 8px;
        height: 8px;
        z-index: 2;
        opacity: 0;
        border-radius: 5px;
        background-color: $white;
        transition: opacity 0.1s linear;
      }
      &.checked .checked-radio {
        opacity: 1;
      }
    }
    .radio-title {
      display: block;
      margin-left: 26px;
    }
  }
}
</style>
